import React, { FunctionComponent } from 'react';

export type PreviouslyViewedProductsProps = {};

/** https://rs-components.atlassian.net/browse/EMD-748 */
export const PreviouslyViewedProducts: FunctionComponent<PreviouslyViewedProductsProps> = (props: PreviouslyViewedProductsProps) => {
  return <div id='home_dmpg1'></div>;
};

export default PreviouslyViewedProducts;
